import React, { useEffect, useState, useMemo } from 'react';
import { AgChartsReact } from 'ag-charts-react';
import {
  AgChartOptions,
  AgHistogramSeriesTooltipRendererParams,
} from 'ag-charts-community';
import { Box, Button, Chip, Grid, Stack, Typography } from '@mui/material';
// import ChartExample from './Chart';
import { Organization } from '../organisation/OrganizationForm';
import { AppDispatch } from '../../reduxStore/Store';
import { useDispatch, useSelector } from 'react-redux';

import { Link, useNavigate } from 'react-router-dom';
import Administration from '../Administration/Administration';
import ChartExample from './index';
import {
  getStudentDashboardAssessmentList,
  getStudentDashboardList,
  getStudentDashboardReports, // ✅ NEW
} from '../../reduxStore/reducer/studentDashboardReducer';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Scrollbar } from 'react-scrollbars-custom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import AssignmentIcon from '@mui/icons-material/Assignment';
import moment from 'moment';
import { green } from '@mui/material/colors';
import StudentReportDialog from './StudentReportDialog';
// import StudentDashboardReportDialog from './StudentDashboardReportDialog';

// ✅ NEW

const StudentDashboard = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [showAllCards, setShowAllCards] = React.useState(false);

  const [cardsData, setCardsData] = React.useState([]);
  const visibleCards = showAllCards
    ? cardsData.filter((card: any) => card.is_active)
    : cardsData.filter((card: any) => card.is_active).slice(0, 4);

  const handleMoreClick = () => {
    setShowAllCards((prevShowAllCards) => !prevShowAllCards);
  };

  const [course, setCourse] = useState(null);
  const [options, setOptions] = useState(null);
  const navigate = useNavigate();

  const handleNavigate = (data: any) => {
    const { administration_number, course_assessment, course_student_id } =
      data;

    navigate(
      `/studentAssessment/addStudent/${data.student_id}/${data.course_assessment_id}/${data.adm_no}`,
      {
        state: {
          signUp: true,
        },
      },
    );
  };

  const [assessment, setAssessment] = useState(null);

  // ✅ NEW STATES
  const [reportData, setReportData] = useState<any[]>([]);
  console.log(reportData, 'reportData123');
  const [reportsOpen, setReportsOpen] = useState(false);
  const [selectedCourseAssessmentId, setSelectedCourseAssessmentId] =
    useState<any>(null);
  const groupedReportData = useMemo(() => {
    const grouped: any = {};

    reportData.forEach((item: any) => {
      const key = item.course_assessment_id;

      if (!grouped[key]) {
        grouped[key] = {
          assessment_name: item.assessment_name,
          course_name: item.course_name,
          course_assessment_id: item.course_assessment_id,
          reports: item.reports || [],
          administrations: [],
          latest_report_submitted_at: null,
          has_student_report: false,
        };
      }

      grouped[key].administrations.push({
        administration_id: item.administration_id,
        course_administration_id: item.course_administration_id,
        course_student_id: item.course_student_id,
        test_status: item.test_status,
        submitted_at: item.submitted_at,
        student_reports: item.student_reports,
      });

      // Only consider a record as a valid report when:
      // 1. test_status is true
      // 2. student_reports exists
      // 3. student_reports has at least one item
      // 4. submitted_at exists
      const hasStudentReport =
        item.test_status === true &&
        Array.isArray(item.student_reports) &&
        item.student_reports.length > 0 &&
        item.submitted_at;

      if (hasStudentReport) {
        grouped[key].has_student_report = true;

        // Keep the MOST RECENT submitted_at
        if (
          !grouped[key].latest_report_submitted_at ||
          new Date(item.submitted_at) >
            new Date(grouped[key].latest_report_submitted_at)
        ) {
          grouped[key].latest_report_submitted_at = item.submitted_at;
        }
      }
    });

    // Sort by latest VALID report submission
    return Object.values(grouped).sort((a: any, b: any) => {
      // Assessments with valid reports first
      if (a.latest_report_submitted_at && !b.latest_report_submitted_at) {
        return -1;
      }

      if (!a.latest_report_submitted_at && b.latest_report_submitted_at) {
        return 1;
      }

      // Both have valid reports -> newest first
      if (a.latest_report_submitted_at && b.latest_report_submitted_at) {
        return (
          new Date(b.latest_report_submitted_at).getTime() -
          new Date(a.latest_report_submitted_at).getTime()
        );
      }

      return 0;
    });
  }, [reportData]);

  useEffect(() => {
    dispatch(
      getStudentDashboardAssessmentList(options, setOptions, setCardsData),
    );

    dispatch(getStudentDashboardList(setCourse, setAssessment));

    // ✅ NEW
    dispatch(getStudentDashboardReports(setReportData));
  }, [dispatch]);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

  const StyledPaper = styled(Paper)(({ theme }) => ({
    width: '100%',
    maxWidth: 560,
    bgcolor: 'background.paper',
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: theme.shadows[3],
  }));

  return (
    <div>
      <Box sx={{ width: '100%' }}>
        <Grid container rowSpacing={5} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          {/* LEFT SIDE */}
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <link
                  rel='stylesheet'
                  href='https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css'
                />
                <div
                  style={{ minHeight: '100px', minWidth: '100px' }}
                  className='mt-4 block relative h-32 rounded overflow-hidden bg-gradient-to-r from-blue-600 to-blue-300 text-white animate__animated animate__bounce shadow-xl'
                >
                  <h2 className='text-gray-100 title-font text-base font-bold p-4'>
                    Course Count
                  </h2>
                  <p className='text-black text-2xl font-bold flex items-center justify-center'>
                    {course}
                  </p>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <Link to='/studentassessment'>
                  <div
                    style={{ minHeight: '100px', minWidth: '100px' }}
                    className='mt-4 block relative h-32 rounded overflow-hidden bg-gradient-to-r from-[#4caf50] to-green-300 text-white animate__animated animate__bounce shadow-xl'
                  >
                    <h2 className='text-gray-100 title-font text-base font-bold p-4'>
                      Assessment Count
                    </h2>
                    <p className='text-black text-2xl font-bold flex items-center justify-center'>
                      {assessment}
                    </p>
                  </div>
                </Link>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={12} xl={12}>
                <div>
                  <ChartExample />
                </div>
              </Grid>
            </Grid>
          </Grid>

          {/* RIGHT SIDE - EXISTING */}
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <Grid item xs={12}>
              <div style={{ padding: '16px 0px' }}>
                <StyledPaper elevation={0}>
                  <Typography
                    variant='h6'
                    component='div'
                    sx={{ px: 2, py: 1, textAlign: 'center' }}
                  >
                    Assessment Administration Dates
                  </Typography>

                  <Scrollbar style={{ width: '100%', height: 410 }}>
                    {visibleCards?.map((d: any) => (
                      <List key={d.id}>
                        <ListItem
                          alignItems='flex-start'
                          sx={{ cursor: 'pointer' }}
                          onClick={() => handleNavigate(d)}
                        >
                          <ListItemAvatar>
                            <Avatar sx={{ bgcolor: green[500] }}>
                              <AssignmentIcon />
                            </Avatar>
                          </ListItemAvatar>

                          <ListItemText
                            children={
                              <>
                                {d.assessment_name}
                                <div style={{ display: 'flex', gap: '20px' }}>
                                  <Chip label={d.course_name} size='small' />
                                  <div>
                                    {d.ass_code} - {d.adm_id}
                                  </div>
                                </div>
                              </>
                            }
                            secondary={
                              <div>
                                Start:{' '}
                                {moment(d.start_date_time).format(
                                  'MM-DD-YYYY hh:mm A',
                                )}
                                <br />
                                End:{' '}
                                {moment(d.end_date_time).format(
                                  'MM-DD-YYYY hh:mm A',
                                )}
                              </div>
                            }
                          />
                        </ListItem>
                        <Divider />
                      </List>
                    ))}

                    {!showAllCards && cardsData.length > 4 && (
                      <Stack spacing={2} sx={{ p: 2 }}>
                        <Button variant='outlined' onClick={handleMoreClick}>
                          More
                        </Button>
                      </Stack>
                    )}
                  </Scrollbar>
                </StyledPaper>
              </div>
            </Grid>
          </Grid>

          {/* ✅ NEW - REPORTS */}
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <StyledPaper sx={{ p: 2 }}>
              <Typography
                variant='h6'
                sx={{ textAlign: 'center', mb: 2, fontWeight: 600 }}
              >
                Assessment Reports
              </Typography>

              <Scrollbar style={{ height: 410 }}>
                <Stack spacing={1.5}>
                  {groupedReportData.map((d: any, index: number) => (
                    <Paper
                      key={index}
                      elevation={1}
                      sx={{
                        px: 2,
                        py: 1.5,
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 2,
                        transition: '0.2s',
                        '&:hover': {
                          boxShadow: 4,
                        },
                      }}
                    >
                      {/* LEFT SIDE */}
                      <Box>
                        <Typography
                          variant='subtitle1'
                          fontWeight={500}
                          sx={{ mb: 0.5 }}
                        >
                          {d.assessment_name}
                        </Typography>

                        <Stack direction='row' spacing={1}>
                          <Chip
                            label={d.course_name}
                            size='small'
                            color='primary'
                            variant='outlined'
                          />
                        </Stack>
                      </Box>

                      {/* RIGHT SIDE BUTTON */}
                      {d.has_student_report && (
                        <Button
                          size='small'
                          variant='contained'
                          onClick={() => {
                            const administration = d.administrations
                              ?.filter(
                                (item: any) =>
                                  item.test_status === true &&
                                  Array.isArray(item.student_reports) &&
                                  item.student_reports.length > 0 &&
                                  item.submitted_at,
                              )
                              .sort(
                                (a: any, b: any) =>
                                  new Date(b.submitted_at).getTime() -
                                  new Date(a.submitted_at).getTime(),
                              )[0];

                            if (!administration) {
                              return;
                            }

                            setSelectedCourseAssessmentId({
                              course_student_id:
                                administration.course_student_id,
                              course_administration_id:
                                administration.course_administration_id,
                              course_assessment_id: d.course_assessment_id,
                            });

                            setReportsOpen(true);
                          }}
                          sx={{
                            textTransform: 'none',
                            borderRadius: 2,
                            minWidth: 120,
                            height: 36,
                          }}
                        >
                          Open Report
                        </Button>
                      )}
                    </Paper>
                  ))}
                </Stack>
              </Scrollbar>
            </StyledPaper>
          </Grid>
        </Grid>

        {/* ✅ DIALOG */}
        {/* {reportsOpen && selectedCourseAssessmentId && (
          <StudentDashboardReportDialog
            open={reportsOpen}
            setOpen={setReportsOpen}
            courseData={selectedCourseAssessmentId}
          />
        )} */}
        {reportsOpen && selectedCourseAssessmentId && (
          <StudentReportDialog
            open={reportsOpen}
            setOpen={setReportsOpen}
            courseData={selectedCourseAssessmentId}
          />
        )}
      </Box>
    </div>
  );
};

export default StudentDashboard;
